export default {
  baseUri: '/api',
  signalRUri: '/signalR',
  webSiteBaseUri: 'https://aweplatinumonline.com',
  stripePublishableKey: 'pk_live_qqhqOHNRcMHEU3np2MCG5iQg'
};
